import { useCourseReport } from './CourseReportContext'
import { useUserReport } from './UserReportContext'

const GetContext = ( context: 'Courses' | 'Users' ) => {
    return context === 'Courses' ? useCourseReport() : useUserReport()
}

export default GetContext